const staffFilters = {
  firstName: null,
  lastName: null,
  active: null,
  includeInactive: null
}

export default () => Object.assign({}, staffFilters)
